import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const Withdrawal = lazy(() => import('../../pages/Withdrawal/WithdrawalPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="/*" element={<Withdrawal />} />
    </Routes>
  );
}

export default PagesRoute;
